import { z } from 'zod';
const ReturnSummarySectionType = {
    INCENTIVE: 'INCENTIVE',
    SUBTOTAL: 'SUBTOTAL',
    PAYMENT: 'PAYMENT',
    SHIPPING: 'SHIPPING',
    RETURN_SHIPPING: 'RETURN_SHIPPING',
    SHOP_NOW_INCENTIVE: 'SHOP_NOW_INCENTIVE',
    FEE: 'FEE',
    LINE_ITEM_FEE: 'LINE_ITEM_FEE',
    TAX: 'TAX',
    // a positive balance under the Stripe minimum credited back, or an exchange held to the delta the customer was charged
    ADJUSTMENT: 'ADJUSTMENT',
};
export const financialSectionItem = z.object({
    type: z.enum(ReturnSummarySectionType),
    label: z.string(),
    amount: z.number(),
});
//# sourceMappingURL=financialSection.js.map